import { IconOptions } from 'primereact/utils';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const CertificatesFilledIcon = (options: IconOptions) => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 62 62'
      fill='currentcolor'
      xmlns='http://www.w3.org/2000/svg'
      {...options.iconProps}
    >
      <g opacity='0.8' fill='currentcolor' fillRule='nonzero'>
        <path
          d='M19,5c-2.76,0 -5,2.24 -5,5v38c0,2.76 2.24,5 5,5h1.01953c-0.66,-1.36 -1.01953,-2.89 -1.01953,-4.5c0,-5.8 4.7,-10.5 10.5,-10.5c5.8,0 10.5,4.7 10.5,10.5c0,1.61 -0.35953,3.14 -1.01953,4.5h8.01953c2.76,0 5,-2.24 5,-5v-38c0,-2.76 -2.24,-5 -5,-5zM21.26953,15.53906h21.23047c0.83,0 1.5,0.67 1.5,1.5c0,0.83 -0.67,1.5 -1.5,1.5h-21.23047c-0.83,0 -1.5,-0.67 -1.5,-1.5c0,-0.83 0.67,-1.5 1.5,-1.5zM21.26953,23.53906h14.23047c0.83,0 1.5,0.67 1.5,1.5c0,0.83 -0.67,1.5 -1.5,1.5h-14.23047c-0.83,0 -1.5,-0.67 -1.5,-1.5c0,-0.83 0.67,-1.5 1.5,-1.5zM29.5,41c-4.14,0 -7.5,3.36 -7.5,7.5c0,1.98 0.7693,3.77914 2.0293,5.11914c0.01,2.19 0,6.91016 0,6.91016c0,0.22 0.55102,0.51992 0.79102,0.41992c2.71,-1.12 4.70898,-1.96875 4.70898,-1.96875c0,0 1.98164,0.85898 4.68164,1.95898c0.24,0.1 0.78906,-0.19992 0.78906,-0.41992v-6.93945c1.25,-1.34 2,-3.12008 2,-5.08008c0,-4.14 -3.36,-7.5 -7.5,-7.5zM29.51953,45.10938c1.86,0 3.37109,1.51109 3.37109,3.37109c0,1.86 -1.51109,3.36914 -3.37109,3.36914c-1.87,0 -3.37891,-1.50914 -3.37891,-3.36914c0,-1.86 1.50891,-3.37109 3.37891,-3.37109z'
          fill={options.fillColor}
        />
      </g>
    </svg>
  );
};

export default CertificatesFilledIcon;
